import type {
  CSSProperties,
  ElementType,
  HTMLAttributes,
  ReactNode,
} from "react";
import "./LayoutPrimitives.scss";

type GridProps = HTMLAttributes<HTMLElement> & {
  align?: CSSProperties["alignItems"];
  as?: ElementType;
  children?: ReactNode;
  columns?: CSSProperties["gridTemplateColumns"];
  gap?: CSSProperties["gap"];
  justify?: CSSProperties["justifyContent"];
  rows?: CSSProperties["gridTemplateRows"];
};

export function Grid({
  align,
  as: Component = "div",
  children,
  className = "",
  columns,
  gap,
  justify,
  rows,
  style,
  ...props
}: GridProps) {
  return (
    <Component
      className={`layout-grid ${className}`.trim()}
      style={{
        ...style,
        ...(align === undefined ? {} : { alignItems: align }),
        ...(gap === undefined ? {} : { gap }),
        ...(columns === undefined ? {} : { gridTemplateColumns: columns }),
        ...(rows === undefined ? {} : { gridTemplateRows: rows }),
        ...(justify === undefined ? {} : { justifyContent: justify }),
      }}
      {...props}
    >
      {children}
    </Component>
  );
}
